import React, { useEffect, useState } from "react";
import Navbar from "../../Navbar";
import Footer from "../../Footer";
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import "./Selectedb2cPlanDetails.scss";
import { useParams } from "react-router-dom";
import { getB2CcustomerDetailsById } from "../../../services/customerOnboarding";
import { TabContext, TabPanel } from "@material-ui/lab";
import moment from "moment";
import { getPaymentLinkForCustomerb2cSelectedPlan } from "../../../services/login";

const Selectedb2cPlanDetails = () => {
  const { id } = useParams();
  const [customerDetails, setCustomerDetails] = useState({});
  const [value, setValue] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  let b2cCustomerMemberdetails =
    customerDetails?.b2cCustomerDetails?.b2cCustomerMemberDetailsRequest;
  let retailPlanAndPricing = customerDetails?.retailPlanAndPricing;

  const formattedDate = (date) => {
    const dob = moment(date);
    const formattedDob = dob.format("MMMM Do, YYYY");
    return formattedDob;
  };

  const getB2cCustomerDetailsById = async () => {
    try {
      const res = await getB2CcustomerDetailsById(id);
      setCustomerDetails(res.data);
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handlePayNow = async () => {
    try {
      setIsSubmitting(true);
      const res = await getPaymentLinkForCustomerb2cSelectedPlan(id);
      if (res.data) {
        alert(
          "Proceeding to Payment Screen. Don't Click back button until finish the payment."
        );
        window.location.href =
          res.data?.data?.instrumentResponse?.redirectInfo?.url;
      }
    } catch (error) {
      console.log(error.message);
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    getB2cCustomerDetailsById();
  }, []);

  return (
    <div>
      <Navbar />
      <Box className="Selectedb2cPlanDetailsMainBox">
        <Card>
          <Typography variant="h5">Selected Plan Details</Typography>
          {/* <Card className="mainCustomerCard">
            <Grid container spacing={1}>
              <Grid item xs={7} sm={4} md={3}>
                <Typography className="heading">Name</Typography>
                <Typography className="content">
                  {customerDetails?.b2cCustomerDetails?.name}
                </Typography>
              </Grid>
              <Grid item xs={5} sm={4} md={3}>
                <Typography className="heading">Plan UniqueId</Typography>
                <Typography className="content">
                  {customerDetails?.b2cCustomerDetails?.planUniqueId}
                </Typography>
              </Grid>
              <Grid item xs={7} sm={4} md={3}>
                <Typography className="heading">Email</Typography>
                <Typography className="content">
                  {customerDetails?.b2cCustomerDetails?.email}
                </Typography>
              </Grid>
              <Grid item xs={5} sm={4} md={3}>
                <Typography className="heading">Number</Typography>
                <Typography className="content">
                  {customerDetails?.b2cCustomerDetails?.number}
                </Typography>
              </Grid>
            </Grid>
          </Card>
          <Card className="priceAndDetails">
            <Grid container spacing={1}>
              <Grid item xs={7} sm={4} md={3}>
                <Typography className="heading">Pincode</Typography>
                <Typography className="content">
                  {customerDetails?.b2cCustomerDetails?.pincode}
                </Typography>
              </Grid>
              <Grid item xs={5} sm={4} md={3}>
                <Typography className="heading">Duration</Typography>
                <Typography className="content">
                  {customerDetails?.b2cCustomerDetails?.duration == "1"
                    ? `${customerDetails?.b2cCustomerDetails?.duration} year`
                    : `${customerDetails?.b2cCustomerDetails?.duration} years`}
                </Typography>
              </Grid>
              <Grid item xs={7} sm={4} md={3}>
                <Typography className="heading">No. of Members</Typography>
                <Typography className="content">
                  {customerDetails?.b2cCustomerDetails?.noOfMembers}
                </Typography>
              </Grid>
              <Grid item xs={5} sm={4} md={3}>
                <Typography className="heading">UniqueId</Typography>
                <Typography className="content">
                  {customerDetails?.b2cCustomerDetails?.uniqueId}
                </Typography>
              </Grid>
            </Grid>
          </Card> */}
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            sx={{ mt: "10px" }}
          >
            <Grid item xs={12} md={12} sm={12}>
              <Card className="mainpersondetails">
                <Box className="namebox">
                  <Typography variant="h5">
                    {customerDetails?.b2cCustomerDetails?.name}
                  </Typography>
                  <Typography>
                    {customerDetails?.b2cCustomerDetails?.planUniqueId}
                  </Typography>
                </Box>
                <Box className="personaldetails">
                  <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  >
                    <Grid item xs={4} md={3}>
                      <Typography className="heading">Plan Type</Typography>
                      <Typography className="content">
                        {customerDetails?.retailPlanAndPricing?.planType}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} md={3}>
                      <Typography className="heading">Pincode</Typography>
                      <Typography className="content">
                        {customerDetails?.b2cCustomerDetails?.pincode}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} md={3}>
                      <Typography className="heading">Plan Duration</Typography>
                      <Typography className="content">
                        {customerDetails?.b2cCustomerDetails?.duration == "1"
                          ? `${customerDetails?.b2cCustomerDetails?.duration}year`
                          : `${customerDetails?.b2cCustomerDetails?.duration}years`}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Typography className="heading">Enrolled Date</Typography>
                      <Typography className="content">
                        {formattedDate(
                          customerDetails?.b2cCustomerDetails
                            ?.merchantTransactionDatetime
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    mt="5px"
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  >
                    <Grid item xs={4} md={3} sm={3}>
                      <Typography className="heading">Phone Number</Typography>
                      <Typography className="content">
                        {customerDetails?.b2cCustomerDetails?.number}
                      </Typography>
                    </Grid>
                    <Grid item xs={8} md={3} sm={6}>
                      <Typography className="heading">Mail Id</Typography>
                      <Typography className="content">
                        {customerDetails?.b2cCustomerDetails?.email}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} md={3} sm={3}>
                      <Typography className="heading">
                        Discounts On Treatment
                      </Typography>
                      <Typography className="content">
                        {customerDetails?.retailPlanAndPricing?.discountPercent}
                        %
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Card>
            </Grid>
          </Grid>
          <Box className="retailPlansAndPricingBox">
            <Typography className="purchaseHeading">Plan Details</Typography>
            <Card className="retailPlansAndPricing">
              <Grid container spacing={1}>
                <Grid item xs={7} sm={4} md={3}>
                  <Typography className="heading">Plan Name</Typography>
                  <Typography className="content">
                    {retailPlanAndPricing?.planName}
                  </Typography>
                </Grid>
                <Grid item xs={5} sm={4} md={3}>
                  <Typography className="heading">Plan Type</Typography>
                  <Typography className="content">
                    {retailPlanAndPricing?.planType}
                  </Typography>
                </Grid>
                <Grid item xs={7} sm={4} md={3}>
                  <Typography className="heading">Plan Tenure</Typography>
                  <Typography className="content">
                    {retailPlanAndPricing?.plantenure == "1"
                      ? `${retailPlanAndPricing?.plantenure} year`
                      : `${retailPlanAndPricing?.plantenure} years`}
                  </Typography>
                </Grid>
                <Grid item xs={5} sm={4} md={3}>
                  <Typography className="heading">Treatment Cover</Typography>
                  <Typography className="content">
                    {retailPlanAndPricing?.treatmentCover}
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Box>

          <Box sx={{ width: "100%", mt: "20px" }}>
            <TabContext value={value}>
              <Box>
                <Tabs
                  variant="scrollable"
                  scrollButtons="auto"
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  {b2cCustomerMemberdetails?.map((el, id) => {
                    return (
                      <Tab
                        sx={
                          value === `${el.name}`
                            ? {
                                backgroundColor: "#2D256C",
                                width: "130px",
                                borderRadius: "0px 0px 0px 0px",
                                color: "white",
                                minHeight: "40px",
                                fontSize: "12px",
                                textTransform: "capitalize",
                                fontWeight: 600,
                              }
                            : {
                                backgroundColor: "white",
                                width: "130px",
                                border: "0.5px solid #D9D9D9",
                                borderRadius: "0px 0px 0px 0px",
                                color: "black",
                                minHeight: "40px",
                                textTransform: "capitalize",
                                fontSize: "12px",
                                fontWeight: 600,
                              }
                        }
                        label={el.name}
                        value={el.name}
                      />
                    );
                  })}
                </Tabs>
              </Box>
              {b2cCustomerMemberdetails?.map((el, id) => {
                return (
                  <TabPanel value={el.name}>
                    <MemberDetails
                      tabvalue={value}
                      memberData={b2cCustomerMemberdetails}
                    />
                  </TabPanel>
                );
              })}
            </TabContext>
          </Box>
          <Box className="priceBox">
            <Card className="priceCard">
              <Grid container spacing={1} sx={{ alignItems: "center" }}>
                <Grid item xs={6} sm={6} md={6}>
                  <Typography className="heading">Price</Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <Typography className="content">
                    {customerDetails?.b2cCustomerDetails?.totalPrice} /-
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={6} sm={6} md={6}>
                  <Typography className="heading">taxes</Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <Typography className="content">
                    {customerDetails?.b2cCustomerDetails?.taxes} /-
                  </Typography>
                </Grid>
              </Grid>
              <Divider orientation="horizontal" />
              <Grid container spacing={1} className="totalGrid">
                <Grid item xs={6} sm={6} md={6}>
                  <Typography className="heading">Total</Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <Typography className="content">
                    {customerDetails?.b2cCustomerDetails?.total} /-
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
            <Button
              type="submit"
              disabled={isSubmitting}
              sx={{
                textAlign: "left",
                color: "#FFFFFF",
                backgroundColor: isSubmitting ? "#898989" : "#2d256c!important",
                textTransform: "capitalize",
                fontSize: "12px",
                padding: "8px 15px",
                borderRadius: "3px",

                "&:hover": { backgroundColor: "#3E2732!important" },
              }}
              onClick={handlePayNow}
            >
              Proceed To Payment
            </Button>
          </Box>
        </Card>
        {/* ---------------------------------footer------------------------------ */}
        <Footer />
      </Box>
    </div>
  );
};

export default Selectedb2cPlanDetails;

const MemberDetails = ({ tabvalue, memberData }) => {
  const selectedMember = memberData.find((member) => member.name === tabvalue);
  console.log("selectedmember", selectedMember);
  const formattedDate = (date) => {
    const dob = moment(date);
    const formattedDob = dob.format("MMMM Do, YYYY");
    return formattedDob;
  };
  const formatRupeesWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  return (
    <div>
      <Card className="membercarddetails">
        <Box className="detailsbox">
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={6} md={3}>
              <Typography className="heading">Date of Birth</Typography>
              <Typography className="content">
                {formattedDate(selectedMember.dob)}
              </Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography className="heading">Gender</Typography>
              <Typography className="content">
                {selectedMember.gender}
              </Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography className="heading">Relation</Typography>
              <Typography className="content">
                {selectedMember.relation}
              </Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography className="heading">Total Coverage Amount</Typography>
              <Typography className="content">
                Rs. {formatRupeesWithCommas(selectedMember?.treatmentCover)}
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Divider />

        {selectedMember?.b2cCustomerQuestionDetails.length > 1 && (
          <Box className="healthinfobox">
            <Typography variant="h4">Health Info Questions</Typography>
            <Grid
              container
              spacing={1}
              columnSpacing={{ xs: 5, sm: 1, md: 1 }}
              mt="10px"
            >
              {selectedMember?.b2cCustomerQuestionDetails?.map((el, id) => {
                return (
                  <>
                    <Grid item md={7} xs={7}>
                      {el.question}
                    </Grid>
                    <Grid item md={5} xs={5}>
                      {el.response}
                    </Grid>
                  </>
                );
              })}
            </Grid>
          </Box>
        )}
      </Card>
    </div>
  );
};
